import cn from '../../../lib/classNames';

import styles from './SectionHeader.module.scss';

type SectionHeaderType = {
	className?: string;
	title: string;
	subTitle?: string;
	textAlign?: 'left' | 'center' | 'right';
};

export default function SectionHeader(props: SectionHeaderType) {
	const { className, title, subTitle, textAlign = 'center' } = props;

	return (
		<div className={cn(styles['section-header-wrap'], styles[`text-${textAlign}`], className)}>
			<h2 className={styles.title}>{title}</h2>
			{subTitle ? <p className={cn(styles['sub-title'], 'sub-title')}>{subTitle}</p> : null}
		</div>
	);
}
